<template>
  <div class="yhAdvertisingManageAdd">
    <el-card>
      <div class="jump-btn">
        <el-button type="primary" @click="jump">{{$t('lang.lab_indexAdBack')}}</el-button>
      </div>
      <el-form ref="ruleForm" :model="ruleForm" :rules="rules" :label-width="require('@/config/enum').c_ws4"
        :label-suffix="require('@/config/enum').c_colon" class="form">
        <!-- 所属项目 -->
        <el-form-item label="所属项目" prop="gardenId">
          <el-select v-if="isAdd==1" class="inputdis" v-model="ruleForm.gardenIds"
            :placeholder="$t('lang.lab_selectCommunity')" multiple filterable clearable @change="change">
            <el-option v-for="item in gardens" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <el-select v-else class="inputdis" v-model="ruleForm.gardenId"
            :placeholder="$t('lang.lab_selectCommunity')">
            <el-option v-for="(item, index)  in garden" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <!-- 标题 -->
        <el-form-item label="标题" prop='adName'>
          <el-input maxlength="20" class="inputdis" v-model="ruleForm.adName"
            placeholder="请输入标题"></el-input>
        </el-form-item>
        <!-- 分类 -->
        <el-form-item label="分类" prop="classify">
          <el-select v-model="ruleForm.classify" placeholder class="inputdis">
            <el-option v-for="item in classifyList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <i @click="typeDialog = true" class="el-icon-warning tipIcon"></i>
        </el-form-item>
        <!-- 排序 -->
        <el-form-item label="排序" prop="sortId">
          <el-input-number placeholder="请输入排序"
            :label="$t('lang.lab_AdverSortText')" v-model="ruleForm.sortId" controls-position="right"
            :min="1" :max="99"></el-input-number>
            <el-tooltip class="item" effect="light" :content=orderByTipFont placement="right">
              <el-button class="noStyle"><i class="el-icon-warning-outline tipIcon"></i></el-button>
            </el-tooltip>
        </el-form-item>
        <!-- 显示期限 -->
        <el-form-item label="显示期限" prop="overdue">
          <el-radio-group v-model="ruleForm.overdue">
            <el-radio label="0">截止至结束时间</el-radio>
            <el-radio label="1">永不过期</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="开始时间" prop="startTs">
          <div>
            <el-date-picker v-model="ruleForm.startTs" type="date" value-format="timestamp"
              placeholder="请选择开始时间" class="inputdis"></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item label="结束时间" prop="endTs" v-if="ruleForm.overdue === '0'">
          <div>
            <el-date-picker v-model="ruleForm.endTs" type="date" value-format="timestamp"
              placeholder="请选择结束时间" class="inputdis"></el-date-picker>
          </div>
        </el-form-item>
        <!-- 链接类型 -->
        <el-form-item label="链接类型" prop="linkType">
          <el-radio-group v-model="ruleForm.linkType">
            <el-radio label="1">内链</el-radio>
            <el-radio label="2">外链</el-radio>
            <el-radio label="3">无</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 跳转链接 -->
        <el-form-item label="跳转链接" prop="linkUrl" v-if="ruleForm.linkType !== '3'">
          <el-input style="width:50%" class="inputdis" v-model="ruleForm.linkUrl"
            placeholder="请输入跳转链接"></el-input>
        </el-form-item>
        <!-- 上传图片 -->
        <el-form-item label="上传图片" prop="imgUrl" ref="imgUrl">
          <upload-file ref="uploading" :accept='accept' upTypes='1' :fileList='fileList' :clears='clears'
            @outputFile="getFile" @removeFile='removeFile'></upload-file>
        </el-form-item>
        <!-- 内容 -->
        <el-form-item label="内容" prop="info" class="editor-width">
          <quill-editor v-model="ruleForm.info" ref="myQuillEditor" :options="editorOption"
            @change="onEditorChange($event)"></quill-editor>
          <span class="editorText"
            v-show="isLength < 10001">{{$t('lang.lab_editor_tip1')}}{{isLength}}{{$t('lang.lab_editor_tip2')}}{{10000-isLength}}{{$t('lang.lab_editor_tip3')}}</span>
          <span class="editorTextTips" v-show="isLength >= 10001">{{$t('lang.lab_editor_tips')}}</span>
        </el-form-item>
        <el-button class="btn-first" @click="resetForm('ruleForm')">{{$t('lang.btn_rest')}}</el-button>
        <el-button class="detailbtn" type="primary" :disabled="isCanUse" @click="onSubmit('ruleForm')">
          {{$t('lang.btn_save')}}</el-button>
      </el-form>
    </el-card>
    <!-- 广告类型说明dialog -->
		<el-dialog title="广告类型说明" width="30%" :visible.sync="typeDialog"
			:close-on-click-modal='false'>
      <img style="display:inline-block;width: 100%; height: auto" src="http://oss.kmyhwy.cn/2025/08/11/24bf0635-e15d-49fb-a82c-b66f719dd759.png"/>
    </el-dialog>
  </div>
</template>

<script>
  import {
    addQuillTitle
  } from '../../../config/quill-title.js'
  import UploadFile from '../../../components/upload_file.vue'
  import {
    mapGetters
  } from 'vuex'
  export default {
    data() {
      // eslint-disable-next-line
      var reg = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/;
      var validatePass = (rule, value, callback) => {
        // 只有当linkType不是3时才验证
        if (this.ruleForm.linkType !== '3') {
          if (value === '') {
            callback(new Error(this.$i18n.t('lang.lab_pleInputLink')))
          } else if (value.length > 512) {
            callback(new Error(this.$i18n.t('lang.lab_BigLink')))
          } else {
            if (!reg.test(value)) {
              callback(new Error(this.$i18n.t('lang.lab_pleInputRLink')))
            }
            callback()
          }
        } else {
          callback()
        }
      }
      
      var validateEndTs = (rule, value, callback) => {
        // 只有当overdue是0时才验证
        if (this.ruleForm.overdue === '0') {
          if (!value) {
            callback(new Error(this.$i18n.t('lang.lab_AdverSelsetEndDate')))
          } else {
            callback()
          }
        } else {
          callback()
        }
      }
      return {
        orderByTipFont: '排序数字越大，广告越优先展示。', // 广告排序说明文案
        typeDialog: false, // 广告类型说明dialog
        accept: '.jpg, .jpeg, .png',
        fileList: [], // 文件列表
        clears: false, // 清空按钮
        isCanUse: true, // 保存按钮可用状态
        isAdd: '', // 添加是1   编辑是0
        id: '', // 广告id
        rules: {
          adName: [{
            required: true,
            message: '请输入标题',
            trigger: 'blur'
          }],
          classify: [{
            required: true,
            message: '请选择分类',
            trigger: 'change'
          }],
          sortId: [{
            required: true,
            message: '请输入排序',
            trigger: 'blur'
          }],
          linkType: [{
            required: true,
            message: '请选择链接类型',
            trigger: 'change'
          }],
          linkUrl: [{
            required: true,
            validator: validatePass,
            trigger: 'blur'
          }],
          overdue: [{
            required: true,
            message: '请选择显示期限',
            trigger: 'change'
          }],
          startTs: [{
            required: true,
            message: this.$i18n.t('lang.lab_AdverSelectBeginDate'),
            trigger: 'change'
          }],
          endTs: [{
            required: true,
            validator: validateEndTs,
            trigger: 'change'
          }],
          imgUrl: [{
            required: true,
            message: this.$i18n.t('lang.lab_pleaseUploadPhotograph'),
            trigger: 'change'
          }],
          info: [{
            required: true,
            message: '请输入内容',
            trigger: 'blur'
          }],
        },
        ruleForm: {
          gardenId: this.$store.getters.gardenId,
          gardenIds: [], // 项目id
          adName: '', // 名称
          classify: 1, // 分类
          sortId: '1', // 排序
          linkType: '3', // 链接类型（1：内链 2：外链 3：无）
          linkUrl: '', // 跳转链接
          overdue: '0', // 默认截止至结束时间
          startTs: Date.parse(new Date()), // 开始时间
          endTs: Date.parse(new Date()), // 结束时间
          imgUrl: '', // 图片链接
          fileList: [], // 上传文件集合
          info: '', // 内容
        },
        oldsearchUnit: [],
        garden: [], // 所选小区
        classifyList: [{
            value: 1,
            label: '首页轮播图'
          },
          {
            value: 2,
            label: '精彩活动'
          },
          {
            value: 3,
            label: '精彩推荐'
          }
        ], // 分类
        isLength: 0, // 富文本字数长度
        editorOption: {
          modules: {
            toolbar: [
              ['bold', 'italic', 'underline', 'strike'], // 加粗，斜体，下划线，删除线
              ['blockquote', 'code-block'], // 引用，代码块
              [{
                header: 1
              }, {
                header: 2
              }], // 标题，键值对的形式；1、2表示字体大小
              [{
                list: 'ordered'
              }, {
                list: 'bullet'
              }], // 列表
              [{
                script: 'sub'
              }, {
                script: 'super'
              }], // 上下标
              [{
                indent: '-1'
              }, {
                indent: '+1'
              }], // 缩进
              [{
                direction: 'rtl'
              }], // 文本方向
              [{
                size: ['small', false, 'large', 'huge']
              }], // 字体大小
              [{
                header: [1, 2, 3, 4, 5, 6, false]
              }], // 几级标题
              [{
                color: []
              }, {
                background: []
              }], // 字体颜色，字体背景颜色
              [{
                font: []
              }], // 字体
              [{
                align: []
              }], // 对齐方式
              ['clean'], // 清除字体样式
              ['image', 'video'] // 上传图片、上传视频
            ]
          },
          theme: 'snow',
          placeholder: this.$i18n.t('lang.lab_text'),
        }
      }
    },
    components: {
      'upload-file': UploadFile
    },
    computed: {
      ...mapGetters({
        gardens: 'userGardenList'
      }),
      editor() {
        return this.$refs.myQuillEditor.quill
      }
    },
    watch: {
      ruleForm: {
        handler(newVal, oldVal) {
          let tempRule = JSON.stringify(newVal)
          console.log(tempRule)
          console.log(this.saveData)
          if (tempRule == this.saveData) {
            this.isCanUse = true
          } else {
            this.isCanUse = false
          }
        },
        deep: true,
        immediate: true
      },
      'ruleForm.linkType': function(newVal) {
        this.$refs.ruleForm.validateField('linkUrl')
      },
      'ruleForm.overdue': function(newVal) {
        if (newVal !== '0' && newVal !== '1') {
          this.ruleForm.overdue = '0' // 默认值
          return
        }
        if (newVal === '1') {
          this.ruleForm.endTs = ''
        }
        this.$refs.ruleForm.validateField('endTs')
      },
    },
    destroyed() {
      window.localStorage.setItem('yhAdvertisingForm', JSON.stringify(this.ruleForm))
      window.localStorage.setItem('yhAdvertisingData', JSON.stringify(this.saveData))
    },
    created() {
      // 获取id 有id是编辑  没有id是添加
      this.id = this.$route.query.id
      if (window.localStorage.getItem('yhAdvertisingForm')) {
        this.ruleForm = JSON.parse(window.localStorage.getItem('yhAdvertisingForm'))
        if (this.ruleForm.imgUrl) {
          this.fileList.push({
            name: '',
            url: this.ruleForm.imgUrl
          })
        }
        if (window.localStorage.getItem('yhAdvertisingData')) {
          this.saveData = JSON.parse(window.localStorage.getItem('yhAdvertisingData'))
        }
      } else {
        if (this.id) {
          this.getDetail()
          this.myGarden()
          this.isAdd = 0
        } else {
          // 添加
          this.isAdd = 1
          this.fileList = []
        }
      }
    },
    methods: {
      // 获取组件值
      getFile(e) {
        this.ruleForm.imgUrl = e
        this.$refs.imgUrl.clearValidate()
      },
      // 移除图片
      removeFile(e) {
        this.fileList = []
        this.ruleForm.imgUrl = ''
      },
      // 详情
      getDetail() {
        let loading = this.$loading()
        this.$get(`/gardenShopAd/${this.id}`).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              const data = res.data
              data.linkType = String(data.linkType)
              data.overdue = String(data.overdue)
              data.startTs = data.startTime ? Date.parse(new Date(data.startTime)) : null
              data.endTs = data.endTime ? Date.parse(new Date(data.endTime)) : null
              this.ruleForm = data
              this.fileList.push({
                name: '',
                url: this.ruleForm.imgUrl
              })
              this.saveData = JSON.stringify(this.ruleForm)
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 返回
      jump() {
        this.$router.push({
          name: 'yhAdvertisingManageList'
        })
      },
      // 小区下拉
      myGarden() {
        let myGardens = [...this.$store.getters.userGardenList]
          let index = myGardens.findIndex(item => item.id === 0)
          if (index != -1) {
            myGardens.splice(index, 1)
          }
          this.garden = myGardens
      },
      // 多选项
      change(val) {
        const allValues = []
        // 将全选"0"加入allValues
        // allValues.push(0)
        for (const item of this.gardens) {
          allValues.push(item.id)
        }
        // 用来储存上一次选择的值，可进行对比
        const oldVal = this.oldsearchUnit.length === 1 ? this.oldsearchUnit[0] : []
        // 若选择全部
        if (val.includes(0)) {
          this.ruleForm.gardenIds = allValues
        }
        // 取消全部选中， 上次有， 当前没有， 表示取消全选
        if (oldVal.includes(0) && !val.includes(0)) {
          this.ruleForm.gardenIds = []
        }
        // 新老数据都有全部选中,那就说明除了全选以外的被选择，所以去掉全选
        if (oldVal.includes(0) && val.includes(0)) {
          const index = val.indexOf(0)
          val.splice(index, 1)
          this.ruleForm.gardenIds = val
        }
        // 全选未选，但是其他选项都全部选上了，则全选选上
        if (!oldVal.includes(0) && !val.includes(0)) {
          if (val.length === allValues.length - 1) {
            this.ruleForm.gardenIds = [0].concat(val)
          }
        }
        // 储存当前选择的最后结果 作为下次的老数据
        this.oldsearchUnit[0] = this.ruleForm.gardenIds
      },
      // 保存方法
      onSubmit(formName) {
        if (this.ruleForm.endTs < this.ruleForm.startTs) {
          this.$message({
            type: 'warning',
            message: '开始时间不能大于结束时间'
          })
          return
        }
        // 添加
        if (this.isAdd == 1) {
          let gardenIds = [...this.ruleForm.gardenIds]
          if (gardenIds.includes(0)) {
            gardenIds = gardenIds.filter(id => id !== 0)
          }
          let params = {
            gardenIds: gardenIds.toString(),
            adName: this.ruleForm.adName,
            classify: this.ruleForm.classify,
            sortId: this.ruleForm.sortId,
            overdue: this.ruleForm.overdue,
            startTs: this.ruleForm.startTs,
            endTs: this.ruleForm.endTs,
            linkType: this.ruleForm.linkType,
            linkUrl: this.ruleForm.linkUrl,
            imgUrl: this.ruleForm.imgUrl,
            info: this.ruleForm.info,
          }
          this.$refs[formName].validate(valid => {
            if (valid) {
              console.log(params)
              this.$post('/gardenShopAd', params).then(res => {
                if (res.errCode == 0) {
                  this.$message({
                    type: 'success',
                    message: '添加成功'

                  })
                  this.$router.push({
                    name: 'yhAdvertisingManageList'
                  })
                  this.pageCount = 1
                } else {
                  this.$message({
                    type: 'success',
                    message: res.errMsg
                  })
                }
              })
            }
          })
        } else if (this.isAdd == 0) {
          // 编辑
          let params = {
            gardenId: this.ruleForm.gardenId,
            adName: this.ruleForm.adName,
            classify: this.ruleForm.classify,
            sortId: this.ruleForm.sortId,
            overdue: this.ruleForm.overdue,
            startTs: this.ruleForm.startTs,
            endTs: this.ruleForm.endTs,
            linkType: this.ruleForm.linkType,
            linkUrl: this.ruleForm.linkUrl,
            imgUrl: this.ruleForm.imgUrl,
            info: this.ruleForm.info,
          }
          this.$refs[formName].validate(valid => {
            if (valid) {
              this.$patch(`/gardenShopAd/${this.id}`, params).then(res => {
                if (res.errCode == 0) {
                  this.$message({
                    type: 'success',
                    message: '修改成功'
                  })
                  this.$router.push({
                    name: 'yhAdvertisingManageList'
                  })
                  this.pageCount = 1
                } else {
                  this.$message({
                    type: 'success',
                    message: res.errMsg
                  })
                }
              })
            }
          })
        }
      },
      // 清空方法
      resetForm(formName) {
        this.clears = true
        this.$refs.ruleForm.clearValidate()
        this.ruleForm.adName = ''
        this.ruleForm.sortId = '1'
        this.ruleForm.classify = 1
        this.ruleForm.overdue = '0'
        this.ruleForm.startTsTs = Date.parse(new Date())
        this.ruleForm.endTs = Date.parse(new Date())
        this.ruleForm.linkType = '3'
        this.ruleForm.linkUrl = ''
        this.fileList = []
        this.ruleForm.fileList = []
        this.ruleForm.imgUrl = ''
        this.ruleForm.info = ''
      },
      // 内容字数提示
      onEditorChange(event) {
        event.quill.deleteText(10000, 4)
        if (this.ruleForm.content === '') {
          this.isLength = 0
        } else {
          this.isLength = event.quill.getLength() - 1
        }
      },
    },
    // 富文本字数限制显示位置
    mounted() {
      addQuillTitle()
    }
  }
</script>

<style lang="scss">
  .yhAdvertisingManageAdd {
    .inputdis{
      width: 30vw;
    }
    .tipIcon{
      font-size: 20px;
      margin-left: 10px;
      vertical-align: middle;
    }
    .noStyle{
      border: none!important;
      padding: 0!important;
    }
    .noStyle:hover{
      background-color: #fff!important;
    }
  }
</style>
